<script setup lang="ts">
import LoadButton from "~/components/Common/Buttons/LoadButton.vue";
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

interface Props {
  title?: string;
  description?: string;
  consequences?: string[];
  cancelText?: string;
  confirmText?: string;
  confirmButtonClass?: string;
  showBackButton?: boolean;
  backText?: string;
  loading?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  title: "Voulez-vous supprimer le participant ?",
  description: "Cette action ne sera pas modifiable.",
  consequences: () => ["Les éventuels documents associés seront supprimés"],
  cancelText: "Annuler",
  confirmText: "Supprimer",
  confirmButtonClass: "button_danger",
  showBackButton: false,
  backText: "Retour",
  loading: false,
});

const emit = defineEmits<{
  cancel: [];
  confirm: [];
  back: [];
}>();

function onCancel() {
  emit("cancel");
}

function onConfirm() {
  emit("confirm");
}

function onBack() {
  emit("back");
}

const isLoading = computed(() => {
  return props.loading;
});
</script>

<template>
  <CenterModal :style="{ 'max-width': '488px', width: '100%' }" @hide="onCancel">
    <template #body>
      <div class="grid p-[24px] gap-[24px] body_regular">
        <div class="flex flex-col gap-2">
          <h4 class="heading_4_demi">
            {{ title }}
          </h4>
          <p class="text-secondary-color">
            {{ description }}
          </p>
        </div>
        <ul v-if="consequences.length" class="list-disc list-inside grid gap-2 body_regular px-2">
          <li v-for="(consequence, index) in consequences" :key="index">
            {{ consequence }}
          </li>
        </ul>
        <div class="flex justify-center gap-[16px]">
          <AppButton v-if="showBackButton" type="outlined" class="w-full" :label="backText" @click="onBack" />
          <AppButton v-else type="outlined" class="w-full" :label="cancelText" @click="onCancel" />
          <LoadButton
            v-model="isLoading"
            :text-confirm="confirmText"
            :class="[confirmButtonClass, 'w-full']"
            force-waiting
            @click="onConfirm"
          />
        </div>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped lang="scss"></style>
